// extracted by mini-css-extract-plugin
export default {"activityCard":"styles__activityCard___VpRSA","highlight":"styles__highlight___FD9lg","disabled":"styles__disabled___xCLMN","titleBlock":"styles__titleBlock___YTHhG"};